import { subMinutes as subMinutesFns } from 'date-fns';

export default function subMinutes(date: Date, minutes: number): Date {
  return subMinutesFns(date, minutes);
}
